"use client";

import React from "react";
import { EditorContent as TiptapEditorContent } from "@tiptap/react";
import { Editor } from "@tiptap/react";
import { cn } from "@/lib/utils";

interface EditorContentProps {
  editor: Editor | null;
  disabled: boolean;
  className?: string;
}

export const EditorContent = React.memo(({ editor, disabled, className }: EditorContentProps) => {
  if (!editor) return null;

  return (
    <TiptapEditorContent
      editor={editor}
      className={cn(
        "prose max-w-none p-3 focus-within:outline-none min-h-[200px] sm:min-h-[250px]",
        "[&_.ProseMirror]:outline-none [&_.ProseMirror]:min-h-[180px] sm:[&_.ProseMirror]:min-h-[230px]",
        "[&_.ProseMirror]:text-sm sm:[&_.ProseMirror]:text-base",
        "[&_.ProseMirror]:leading-relaxed",
        "[&_.ProseMirror_img]:max-w-full [&_.ProseMirror_img]:h-auto [&_.ProseMirror_img]:rounded-md [&_.ProseMirror_img]:my-2",
        "[&_.ProseMirror_p.is-editor-empty:first-child::before]:content-[attr(data-placeholder)]",
        "[&_.ProseMirror_p.is-editor-empty:first-child::before]:text-muted-foreground",
        "[&_.ProseMirror_p.is-editor-empty:first-child::before]:float-left",
        "[&_.ProseMirror_p.is-editor-empty:first-child::before]:pointer-events-none",
        "[&_.ProseMirror_p.is-editor-empty:first-child::before]:h-0",
        disabled && "opacity-50 cursor-not-allowed",
        className
      )}
    />
  );
});

EditorContent.displayName = "EditorContent";
